// Réponses rapides pour l'atelier (admin) dans les tickets/chat.
export const CANNED_REPLIES = [
  {
    id: "antifraud",
    label: "🛡️ Multi-comptes (anti-fraude)",
    text:
      "Bonjour,\n\n" +
      "Merci de votre confiance et de l'intérêt que vous portez à nos services.\n\n" +
      "Notre système de sécurité a détecté la création de plusieurs comptes associés à une même " +
      "utilisation (adresses e-mail différentes). Pour la protection de tous nos clients et la " +
      "fiabilité de notre plateforme, notre pare-feu anti-fraude n'autorise qu'un seul compte par utilisateur.\n\n" +
      "Nous sommes convaincus qu'il s'agit d'un simple oubli, et aucune sanction n'a été appliquée à ce stade.\n\n" +
      "Afin d'éviter toute suspension automatique de vos accès, nous vous invitons simplement à :\n" +
      "• Conserver un seul compte (celui de votre choix),\n" +
      "• Ne plus créer de nouvelles adresses pour accéder au service.\n\n" +
      "Si vous rencontrez un problème d'accès, un souci de crédits ou toute autre difficulté, " +
      "écrivez-nous directement : notre équipe se fera un plaisir de vous aider et de tout régler ensemble.\n\n" +
      "Merci de votre compréhension et à très bientôt,\n" +
      "L'équipe IMPERIUM · Automotive Files",
  },
  {
    id: "processing",
    label: "⏳ En cours de traitement",
    text:
      "Bonjour,\n\nVotre fichier est en cours de traitement par notre atelier. Nous revenons vers vous " +
      "très rapidement avec la solution. Merci de votre patience 🙏\n\nL'équipe IMPERIUM · Automotive Files",
  },
  {
    id: "delivered",
    label: "✅ Fichier livré",
    text:
      "Bonjour,\n\nVotre fichier est prêt et disponible au téléchargement depuis votre commande. " +
      "N'hésitez pas à nous faire un retour une fois installé. Bonne route ! 🚗💨\n\nL'équipe IMPERIUM · Automotive Files",
  },
  {
    id: "needinfo",
    label: "❓ Besoin d'informations",
    text:
      "Bonjour,\n\nAfin de traiter votre demande au mieux, pourriez-vous nous préciser quelques informations " +
      "(véhicule, motorisation, lecture du fichier, outil utilisé) ? Merci d'avance 🙏\n\nL'équipe IMPERIUM · Automotive Files",
  },
];
